import theme from '../../muiTheme';

const styles = {


    rootBox: {
        minHeight: '100vh', 
        padding: '20px 0px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        background: 'linear-gradient(to right, #b24592, #f15f79)',
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
            background: 'white',
            padding: '20px 0px'
        }
    },
    container: {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
            padding: '0px'
        }
    },
    paper : {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(5),
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
            //padding: theme.spacing(0),
        }
    },
    title : {
        marginBottom: theme.spacing(2)
    },
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        marginTop: theme.spacing(3),
        display: 'flex', 
        justifyContent: 'space-evenly', 
        alignItems: 'center', 
        flexDirection: 'column'
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        [theme.breakpoints.down('sm')]: {
            padding: '13px 35px',
        }
    },
    googleButton: {
        marginBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    signUpGrid: {
        marginTop: theme.spacing(2)
    },
    formBox: {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        flexDirection: 'column',
        width: '400px',
        [theme.breakpoints.down('sm')]: {
            width: '80vw',
        }
    }, 
    textField: {
        width: '100%',
        margin: '10px 0px',
        background: theme.palette.faint,
        borderRadius: '15px',

        '& .MuiInputBase-root': {
            borderRadius: '15px'
            
        },

        '& fieldset': {
            borderColor: 'transparent'
        },

        '& fieldset': {
            borderColor: 'transparent'
        },
        
        '& label': {
            transition: '0.4s',
            background: theme.palette.faint,
            padding: '1px 15px',
            borderRadius: '20px',
        },

        '& .MuiInputBase-root input:-internal-autofill-selected': {
            backgroundColor: 'transparent !important'
        },

        '& label.Mui-focused ': {

            padding: '3px 15px',
            borderRadius: '20px',
            marginLeft: '-5px',
            background: theme.palette.primary.main,
            color: 'white'
        },

        '& .MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline' : {
            borderWidth: '2px'
        }
    },

    input: {
        '&:-webkit-autofill': {
            WebkitBoxShadow: "0 0 0 1000px white inset"
        },
    }

}

export default styles; 